// styles
import styled from 'styled-components';
const SoFormCandidateBlockDetailsInputLabel = styled.div`
  width: 276px;
  height: 16px;

  /* 12px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* grey / 500 */

  color: #94a6b8;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

export default SoFormCandidateBlockDetailsInputLabel;
